import React, { useState, useEffect, useRef } from 'react'
import {
    useAppDimensioRowsMutation,
    useManageAppDimensionRowsMutation,
} from '../../Redux/Admin_Tasks/DimensionSlice/ManageDimensionSLice'
import { FoundationsButton } from '../../GenericComponents/button' //Done
import { FoundationsInput } from '../../GenericComponents/input'
import FoundationsSelect from '../../GenericComponents/select'
import { Skeleton } from '../../GenericComponents/Skeleton'
import { useTitleContext } from '../../Hooks/useTitleContext'
import { onEnter } from '../../GlobalMethods'

const ManageAppDimensionRows: React.FC = () => {
    const [appDimensioRows, { data, error, isLoading }] = useAppDimensioRowsMutation()
    const [currentPage, setCurrentPage] = useState(1)
    const [searchText, setSearchText] = useState('')
    const [tempSearchText, setTempSearchText] = useState('')
    const [GuidValue, setGuidValue] = useState<string | null>(null)
    const { setTitle } = useTitleContext()
    const [totalItems, setTotalItems] = useState(0)
    const [totalPages, setTotalPages] = useState(1)
    const [allPages, setAllPages] = useState(1)
    const [headers, setHeaders] = useState<string[]>([])
    const [headerslen, setHeaderslen] = useState<string[]>([])

    // const totalItems = data.AppDimensionRowCount
    //         const AllPages = Math.ceil(totalItems / itemsPerPage)
    //         const totalPages = Math.min(AllPages, 150)
    setTitle('Dimension Manager')

    useEffect(() => {
        const hash = window.location.hash
        const queryIndex = hash.indexOf('?')
        if (queryIndex !== -1) {
            const queryString = hash.substring(queryIndex + 1)
            const queryParams = new URLSearchParams(queryString)
            const guidFromUrl = queryParams.get('Guid')

            setGuidValue(guidFromUrl)
        }
    }, [])

    useEffect(() => {
        updateData()
    }, [GuidValue, currentPage, searchText])

    const updateData = ()=>{
        if (GuidValue){
            appDimensioRows({
                AppDimensionGuid: GuidValue,
                PageNumber: currentPage,
                PageSize: 10,
                SearchText: searchText,
                SortDir: 'asc',
                SortField: '',
            })
                .unwrap()
                .then((response) => {
                    //revist later to remove this callback. Debugging listening for rtk query state change was taking too long for now
                    const itemsPerPage = 10
                    setAllPages(Math.ceil(response.AppDimensionRowCount / itemsPerPage))
                    setTotalItems(response.AppDimensionRowCount || 0)
                    setTotalPages(
                        Math.min(Math.ceil(response.AppDimensionRowCount / itemsPerPage), 150)
                    )
                })
                .catch((error) => {
                    console.error('API call failed:', error)
                })
        }
    }

    const handleManageClick = (guid: string, rowId: any) => {
        window.location.hash = `#EditAppDimensionRows?Guid=${guid}&rowId=${rowId}`
    }

    const handleSearchInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        setTempSearchText(e.target.value.toLowerCase())
    }
    const handleSearch = () => {
        if (data && data.AppDimensionRows) {
            setSearchText(tempSearchText)
            setCurrentPage(1)
        }
    }
    
    const handlePageChange = (pageNumber: number) => {
        if (pageNumber >= 1 && pageNumber <= totalPages) {
            setCurrentPage(pageNumber)
        }
    }

    useEffect(() => {
        if (Array.isArray(data?.AppDimensionFields)) {
            setHeaders(
                data.AppDimensionFields.filter((item: any) => item.ViewableInUI === 'Y').map(
                    (item: any) => item.FieldName
                )
            )
            setHeaderslen(
                data.AppDimensionFields.filter((item: any) => item.ViewableInUI === 'Y').map(
                    (item: any) => item.FieldDescription
                )
            )
        }
    }, [data?.AppDimensionFields])

    return (
        <>
            <div id="dimension-manager">
                <div id="dimension-manager">
                    <div>
                        <div className="content">
                            <Skeleton loading={isLoading} height="40px" width="100%">
                                <div className="float-right margin-top-small">
                                    <a id="link_backto_admin_tasks" href={`#AdminTasks`}>
                                        &laquo; Back to Admin Tasks
                                    </a>
                                </div>
                                <div className="header">Manage Dimensions</div>
                                <h3 className="float-left">Manage {data?.AppDimension.Name} Rows</h3>
                                <div className="float-right margin-top-small">
                                    <a
                                        id="dimension"
                                        className="back-to-dimensions"
                                        href={`#appdimensions`}
                                    >
                                        &laquo; Back to Dimensions
                                    </a>
                                    <span className="admin-menu-divider">&bull;</span>
                                    <span className="sub-info" id="filteredRowsLen">
                                        {data?.AppDimensionRows.length}
                                    </span>
                                    <span className="sub-info"> rows</span>
                                    <span className="admin-menu-divider">&bull;</span>
                                    <a
                                        className="add-new-row"
                                        href={`#appdimensions/add?Guid=${GuidValue}`}
                                        data-guid={data?.appDimensionguid}
                                    >
                                        <i className="icon-plus-sign"></i>Add New Row
                                    </a>
                                </div>
                            </Skeleton>
                            <div className="clear-both"></div>
                            <Skeleton loading={isLoading} height="30px" width="70%">
                                <div className="admin-search">
                                    <div className="row">
                                        <div className="col-lg-12">
                                            <div className="input-group">
                                                <FoundationsInput
                                                    inputClasses="form-control"
                                                    type="text"
                                                    id="searchTextAppdim"
                                                    name="searchText"
                                                    placeHolder="Search..."
                                                    value={tempSearchText}
                                                    maxLength={100}
                                                    labelText="" //FP-10482 : Empty labeltext for this input box
                                                    customStyle={{ height: '30px', width: '100%' }} //FP-10482 : Width resizes with screen size
                                                    data-enter="appDimensionRowData"
                                                    onKeyDown={(e) => onEnter(e, handleSearch)}
                                                    onInput={handleSearchInputChange}
                                                    key="searchTextAppdim"
                                                />
                                                <span
                                                    style={{
                                                        display: 'flex',
                                                        alignItems: 'center',
                                                        gap: '5px',
                                                    }}
                                                >
                                                    <FoundationsButton
                                                        buttonClasses="app-button"
                                                        type="button"
                                                        id="search"
                                                        onClick={handleSearch}
                                                    >
                                                        Search
                                                    </FoundationsButton>
                                                    <FoundationsButton
                                                        buttonClasses="app-button negative"
                                                        type="button"
                                                        id="clear"
                                                        onClick={() => {
                                                            setTempSearchText('')
                                                            setSearchText('')
                                                            setCurrentPage(1)
                                                        }}
                                                    >
                                                        Clear
                                                    </FoundationsButton>
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </Skeleton>
                            <br />
                            <Skeleton
                                loading={isLoading}
                                height="40px"
                                width="100%"
                                style={{ marginBottom: '10px' }}
                            >
                                <div className="clear-both"></div>
                                <table
                                    className="admin-table wrap-and-break"
                                    id="tblAppDimensionFields"
                                    style={{
                                        marginBottom: '20px',
                                        width: '100%',
                                        whiteSpace: 'normal',
                                    }}
                                >
                                    <thead>
                                        <tr className="admin-row-header">
                                            {data?.AppDimensionFields.map((field: any) => (
                                                <React.Fragment key={field.FieldName}>
                                                    {field.PrimaryKey === 'Y' && <th>Action(s)</th>}
                                                    {field.ViewableInUI === 'Y' && (
                                                        <>
                                                            <th>{field.FieldDescription}</th>
                                                        </>
                                                    )}
                                                </React.Fragment>
                                            ))}
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {data?.AppDimensionRows !== undefined &&
                                        data?.AppDimensionRows.length === 0 ? (
                                            <>
                                                <tr>
                                                    <td colSpan={headerslen.length + 1}>
                                                        No Result Found
                                                    </td>
                                                </tr>
                                            </>
                                        ) : data?.AppDimensionRows.length === 0 &&
                                          data?.AppDimensionRows.length === 0 ? (
                                            <>
                                                <tr>
                                                    <td colSpan={headerslen.length + 1}>
                                                        No dimension fields defined.
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td colSpan={headerslen.length + 1}>
                                                        No rows found.
                                                    </td>
                                                </tr>
                                            </>
                                        ) : data?.AppDimensionRows.length === 0 ? (
                                            <>
                                                <tr>
                                                    {data?.AppDimensionRows.length === 0 ? (
                                                        <td colSpan={headerslen.length + 1}>
                                                            No dimension fields defined.
                                                        </td>
                                                    ) : (
                                                        data?.map((data: any) => (
                                                            <td key={data}>{data}</td>
                                                        ))
                                                    )}
                                                </tr>
                                                <tr>
                                                    <td colSpan={headerslen.length + 1}>
                                                        No rows found.
                                                    </td>
                                                </tr>
                                            </>
                                        ) : (
                                            data?.AppDimensionRows.map((row: any, rowIndex: any) => (
                                                <tr key={rowIndex} className="admin-row-data">
                                                    <td>
                                                        {row._key && (
                                                            <a
                                                                className="app-button"
                                                                id="editButton"
                                                                onClick={() =>
                                                                    handleManageClick(
                                                                        data?.AppDimension.Guid,
                                                                        row._key
                                                                    )
                                                                }
                                                                data-guid={data?.Guid}
                                                                data-rowid={row._key}
                                                            >
                                                                Edit
                                                            </a>
                                                        )}
                                                        {row.Id && (
                                                            <a
                                                                className="app-button"
                                                                id="editButton"
                                                                onClick={() =>
                                                                    handleManageClick(
                                                                        data?.AppDimension.Guid,
                                                                        row.Id
                                                                    )
                                                                }
                                                                data-guid={data?.Guid}
                                                                data-rowid={row.Id}
                                                            >
                                                                Edit
                                                            </a>
                                                        )}
                                                        {row.FieldKey && (
                                                            <a
                                                                className="app-button"
                                                                id="editButton"
                                                                onClick={() =>
                                                                    handleManageClick(
                                                                        data?.AppDimension.Guid,
                                                                        row.FieldKey
                                                                    )
                                                                }
                                                                data-guid={data?.Guid}
                                                                data-rowid={row.FieldKey}
                                                            >
                                                                Edit
                                                            </a>
                                                        )}
                                                    </td>

                                                    {headers.map((data: any) => (
                                                        <td key={data}>{row[data]}</td>
                                                    ))}
                                                </tr>
                                            ))
                                        )}
                                    </tbody>
                                </table>
                                <div className="text-right">
                                    <div className="pagination-container text-right">
                                        <ul
                                            className="pagination"
                                            style={{ display: 'flex', justifyContent: 'right' }}
                                        >
                                            <li
                                                className="page-item"
                                                style={{
                                                    display: 'inline-block',
                                                    marginLeft: '5px',
                                                }}
                                            >
                                                <a
                                                    className={`page-link ${currentPage === 1 ? 'disabled' : ''}`}
                                                    href="#"
                                                    onClick={(e) => {
                                                        e.preventDefault()
                                                        if (currentPage === 1) {
                                                            e.preventDefault()
                                                        } else {
                                                            handlePageChange(1)
                                                        }
                                                    }}
                                                    style={{
                                                        padding: '8px 12px',
                                                        borderRadius: '5px',
                                                        cursor:
                                                            currentPage === 1
                                                                ? 'not-allowed'
                                                                : 'pointer',
                                                        pointerEvents:
                                                            currentPage === 1 ? 'none' : 'auto',
                                                        color:
                                                            currentPage === 1
                                                                ? '#5b5b5d'
                                                                : '#4297d7',
                                                        textDecoration: 'none',
                                                    }}
                                                >
                                                    FIRST
                                                </a>
                                            </li>
                                            <li
                                                className="page-item"
                                                style={{
                                                    display: 'inline-block',
                                                    marginLeft: '5px',
                                                }}
                                            >
                                                <a
                                                    className={`page-link ${currentPage === 1 ? 'disabled' : ''}`}
                                                    href="#"
                                                    onClick={(e) => {
                                                        e.preventDefault()
                                                        if (currentPage === 1) {
                                                            e.preventDefault()
                                                        } else {
                                                            handlePageChange(currentPage - 1)
                                                        }
                                                    }}
                                                    style={{
                                                        padding: '8px 12px',
                                                        borderRadius: '5px',
                                                        cursor:
                                                            currentPage === 1
                                                                ? 'not-allowed'
                                                                : 'pointer',
                                                        pointerEvents:
                                                            currentPage === 1 ? 'none' : 'auto',
                                                        color:
                                                            currentPage === 1
                                                                ? '#5b5b5d'
                                                                : '#4297d7',
                                                        textDecoration: 'none',
                                                    }}
                                                >
                                                    PREV
                                                </a>
                                            </li>
                                            <li
                                                className="page-item"
                                                style={{
                                                    display: 'inline-block',
                                                    marginLeft: '5px',
                                                }}
                                            >
                                                <a
                                                    className={`page-link ${currentPage === totalPages ? 'disabled' : ''}`}
                                                    href="#"
                                                    onClick={(e) => {
                                                        e.preventDefault()
                                                        if (currentPage === totalPages) {
                                                            e.preventDefault()
                                                        } else {
                                                            handlePageChange(currentPage + 1)
                                                        }
                                                    }}
                                                    style={{
                                                        padding: '8px 12px',
                                                        borderRadius: '5px',
                                                        cursor:
                                                            currentPage === totalPages
                                                                ? 'not-allowed'
                                                                : 'pointer',
                                                        pointerEvents:
                                                            currentPage === totalPages
                                                                ? 'none'
                                                                : 'auto',
                                                        color:
                                                            currentPage === totalPages
                                                                ? '#5b5b5d'
                                                                : '#4297d7',
                                                        textDecoration: 'none',
                                                    }}
                                                >
                                                    NEXT
                                                </a>
                                            </li>
                                            <li
                                                className="page-item"
                                                style={{
                                                    display: 'inline-block',
                                                    marginLeft: '5px',
                                                }}
                                            >
                                                <a
                                                    className={`page-link ${currentPage === totalPages ? 'disabled' : ''}`}
                                                    href="#"
                                                    onClick={(e) => {
                                                        e.preventDefault()
                                                        if (currentPage === totalPages) {
                                                            e.preventDefault()
                                                        } else {
                                                            handlePageChange(totalPages)
                                                        }
                                                    }}
                                                    style={{
                                                        padding: '8px 12px',
                                                        borderRadius: '5px',
                                                        cursor:
                                                            currentPage === totalPages
                                                                ? 'not-allowed'
                                                                : 'pointer',
                                                        pointerEvents:
                                                            currentPage === totalPages
                                                                ? 'none'
                                                                : 'auto',
                                                        color:
                                                            currentPage === totalPages
                                                                ? '#5b5b5d'
                                                                : '#4297d7',
                                                        textDecoration: 'none',
                                                    }}
                                                >
                                                    LAST
                                                </a>
                                            </li>
                                            <li
                                                className="page-item"
                                                style={{
                                                    display: 'inline-block',
                                                    marginLeft: '5px',
                                                }}
                                            >
                                                <FoundationsSelect
                                                    id="ManageDimRows"
                                                    defaultValue={currentPage}
                                                    onChange={(
                                                        e: React.ChangeEvent<HTMLSelectElement>
                                                    ) => handlePageChange(Number(e.target.value))}
                                                    selectClasses="PaginationDropdown"
                                                >
                                                    {Array.from(
                                                        { length: Math.min(totalPages, 150) },
                                                        (_, i) => i + 1
                                                    ).map((pageNumber) => (
                                                        <option key={pageNumber} value={pageNumber}>
                                                            {pageNumber}
                                                        </option>
                                                    ))}
                                                </FoundationsSelect>
                                            </li>
                                        </ul>
                                    </div>
                                    <div
                                        id="divTooManyRows"
                                        className={allPages > 150 ? 'show' : 'hide'}
                                        style={{ color: 'red', fontSize: 'small' }}
                                    >
                                        Only 150 pages are generated due to a large number of
                                        records. Please use the Find functionality or the Next
                                        button.
                                    </div>
                                </div>
                            </Skeleton>
                            <Skeleton loading={isLoading} height="30px" width="70%" />
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default ManageAppDimensionRows
